export default __webpack_public_path__ + "static/media/givepower_TM_logo_Horizontal_Black.76497b79.svg";